export const roundRub = (value: number) => Math.round(value)

export const roundRubAmountString = (value: string) => {
  const trimmed = value.trim()
  if (!trimmed) return ''

  const parsed = Number(trimmed.replace(/\s/gu, '').replace(',', '.'))
  return Number.isFinite(parsed) ? String(roundRub(parsed)) : value
}
